var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReturn = function SvgReturn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.88598 4.66662L5.57665 6.35728L4.63398 7.29995L1.33398 3.99995L4.63398 0.699951L5.57665 1.64262L3.88598 3.33328H8.66732C10.0818 3.33328 11.4384 3.89519 12.4386 4.89538C13.4387 5.89558 14.0007 7.25213 14.0007 8.66662C14.0007 10.0811 13.4387 11.4377 12.4386 12.4379C11.4384 13.438 10.0818 14 8.66732 14H2.66732V12.6666H8.66732C9.72818 12.6666 10.7456 12.2452 11.4957 11.495C12.2459 10.7449 12.6673 9.72748 12.6673 8.66662C12.6673 7.60575 12.2459 6.58834 11.4957 5.83819C10.7456 5.08805 9.72818 4.66662 8.66732 4.66662H3.88598Z"
  })));
};
export default SvgReturn;